export default __webpack_public_path__ + "static/media/image_block_default.07a8638e.svg";